<template>
  <div :class="prefix+'transfer'">
    <t-transfer-list
      ref="left"
      :checked-key="leftCheckedKeys"
      :data="leftData"
      :filter-method="filterMethod"
      :filter-placeholder="filterPlaceholderState"
      :filterable="filterable"
      :not-found-text="notFoundTextState"
      :render-content="renderContent"
      :show-footer="showFooter"
      :size="size"
      :title="titles && titles[0] ? titles[0] : ''"
      direction="left"
    >
      <template slot="listBody" slot-scope="filteredDatas">
        <slot name="listBodyLeft" :data="filteredDatas.data"></slot>
      </template>
      <div slot="list-footer">
        <slot name="left-footer"></slot>
      </div>
    </t-transfer-list>
    <t-transfer-operation ref="operation" :operations="operations" :size="size"></t-transfer-operation>
    <t-transfer-list
      ref="right"
      :checked-key="rightCheckedKeys"
      :data="rightData"
      :filter-method="filterMethod"
      :filter-placeholder="filterPlaceholderState"
      :filterable="filterable"
      :not-found-text="notFoundTextState"
      :render-content="renderContent"
      :show-footer="showFooter"
      :size="size"
      :title="titles && titles[1] ? titles[1] : ''"
      direction="right"
    >
      <template slot="listBody" slot-scope="filteredDatas">
        <slot name="listBodyRight" :data="filteredDatas.data"></slot>
      </template>
      <div slot="list-footer">
        <slot name="right-footer"></slot>
      </div>
    </t-transfer-list>
  </div>
</template>

<script>
import TTransferList from './list.vue'
import TTransferOperation from './operation.vue'
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'TTransfer',
  components: {
    TTransferList,
    TTransferOperation
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    targetKeys: {
      type: Array,
      default() {
        return []
      }
    },
    selectedKeys: {
      type: Array,
      default() {
        return []
      }
    },
    titles: {
      type: Array,
      default() {
        return ['Source', 'Target']
      }
    },
    operations: {
      type: Array,
      default() {
        return []
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    filterMethod: {
      type: Function,
      default(data, query) {
        if (data) {
          const type = 'label' in data ? 'label' : 'key'
          return (data[type] + '').indexOf(query) > -1
        } else {
          return false
        }
      }
    },
    notFoundText: {
      type: String,
      default: '暂无数据'
    },
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'sm'].includes(value)
      }
    },
    renderContent: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      prefix: PREFIX_CLASS,
      leftData: [],
      rightData: [],
      leftCheckedKeys: [],
      rightCheckedKeys: [],
      tKeys: this.targetKeys
    }
  },
  computed: {
    filterPlaceholderState() {
      return this.filterPlaceholder
    },
    notFoundTextState() {
      return this.notFoundText
    }
  },
  watch: {
    data(newVal) {
      if (!newVal || !newVal.length || newVal.length === 0) {
        this.tKeys = []
      }
      this.$_splitData(false)
    },
    targetKeys(newVal) {
      this.tKeys = newVal.length ? newVal : []
      this.$_splitData(false)
    },
    selectedKeys(newVal) {
      this.$_splitSelectedKey(newVal)
    }
  },
  created: function() {
    this.$_splitData(true)
  },
  methods: {
    $_splitData(initial = false) {
      this.leftData = this.data ? this.data.slice() : []
      this.rightData = []
      if (this.tKeys.length > 0) {
        this.leftData = this.leftData.filter((data, i) => {
          if (this.tKeys.includes(data.key)) {
            this.rightData.push(data)
            return false
          } else {
            return true
          }
        })
      }
      if (initial) {
        this.$_splitSelectedKey()
      }
    },
    $_splitSelectedKey(selectedKeys = this.selectedKeys) {
      // this.leftData = this.data.slice()
      let _leftChecked = []
      let _rightChecked = []
      for (let data of this.leftData) {
        if (selectedKeys.includes(data.key)) {
          _leftChecked.push(data.key)
        }
      }
      this.leftCheckedKeys = _leftChecked
      for (let data of this.rightData) {
        if (selectedKeys.includes(data.key)) {
          _rightChecked.push(data.key)
        }
      }
      this.rightCheckedKeys = _rightChecked
    },
    moveTo(direction) {
      let targetKeys = this.tKeys.slice()
      let dest = direction === 'left' ? 'right' : 'left'
      const moveKeys = this.$refs[dest].checkedKeys
      const destKeys =
        direction === 'right'
          ? moveKeys.concat(targetKeys)
          : targetKeys.filter(
            targetKey =>
              !moveKeys.some(checkedKey => targetKey === checkedKey)
          )
      this.tKeys = destKeys
      this.$_splitData()
      this.$refs[dest].checkAll(false)
      this.$emit('change', destKeys, direction, moveKeys)
    },
    handleCheckedChange(direction, keys) {
      this[`${direction}CheckedKeys`] = keys
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/transfer/transfer.vue